<template>
  <div class="flex flex-row w-screen h-screen relative bg-gray-50">
    <BaseSidebar />
    <div class="h-full w-full flex flex-col flex-1 overflow-y-scroll">
      <Breadcrumb
        :model="breadcrumbItems"
        class="bg-transparent !shrink-0"
      >
        <template #item="{ item }">
          <a
            class="cursor-pointer"
            :href="item.to"
          >
            <span>{{ item.label }}</span>
          </a>
        </template>
        <template #separator>
          /
        </template>
      </Breadcrumb>
      <div
        class="flex flex-row w-full h-screen h-full"
      >
        <TemplateSidebar />

        <div class="h-full w-full flex flex-col flex-1 bg-gray-100 overflow-y-auto">
          <div class="p-6 rounded-md">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()

const breadcrumbItems = computed(() => {
  if (route.name == 'templates-cim') {
    return [
      { label: 'Templates', to: '/templates' },
      { label: 'CIM Templates', to: '/templates/cim' },
    ]
  }
  else if (route.name == 'templates-teaser') {
    return [
      { label: 'Templates', to: '/templates' },
      { label: 'Teaser Templates', to: '/templates/teaser' },
    ]
  }
  else if (route.name == 'templates-proposal') {
    return [
      { label: 'Templates', to: '/templates' },
      { label: 'Proposal Templates', to: '/templates/proposal' },
    ]
  }
  else if (route.name == 'templates-confidentiality-agreement') {
    return [
      { label: 'Templates', to: '/templates' },
      { label: `NDA Manager`, to: '/templates/confidentiality-agreement' },
    ]
  }
  else if (route.name == 'templates-folders') {
    return [
      { label: 'Templates', to: '/templates' },
      { label: 'Folders', to: '/templates/folders' },
    ]
  }
  else if (route.name == 'templates-resources') {
    return [
      { label: 'Templates', to: '/templates' },
      { label: 'Resources', to: '/templates/resources' },
    ]
  }
  else if (route.name == 'templates-forms') {
    return [
      { label: 'Templates', to: '/templates' },
      { label: 'Forms', to: '/templates/forms' },
    ]
  }
  else if (route.name == 'templates-message') {
    return [
      { label: 'Templates', to: '/templates' },
      { label: 'SMS / Email', to: '/templates/message' },
    ]
  }
  else if (route.name == 'templates-business-campaign') {
    return [
      { label: 'Templates', to: '/templates' },
      { label: 'Business Campaign', to: '/templates/business-campaign' },
    ]
  }
  else {
    return []
  }
})
</script>
